import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLoadScript, StandaloneSearchBox } from "@react-google-maps/api";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import swal from "sweetalert";
import CreatableSelect from "react-select/creatable";
import { Pagination } from "antd";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import AddOfferPopup from "./AddOfferPopup";
import formatError from "../../services/FormatError";
import { sortList } from "./Users";

import {
  addBusinessData,
  bookmarkBusiness,
  buyerInterestedinBusiness,
  deleteBusinessDetails,
  fetchAllBusiness,
  fetchBusinessDetails,
  fetchBuyerBusinesses,
  fetchSellerBusinessDetails,
  getAllbookmarkBusinesses,
  getOffersRaisedBusinesses,
} from "../../services/BusinessService";
import { fetchActiveCurrencies } from "../../services/Currencies";
import Rating from "../components/UIComponents/Rating";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "react-multi-select-component";
import { createChatRoom } from "../../services/ChatService";
import { msgAction, roomAction } from "../../store/actions/MsgAction";
import { chatAction } from "../../store/actions/ChatActions";
import { Icon } from "@iconify/react/dist/iconify.js";
import { globalFileUploader } from "../components/UIComponents/uploader";
import BusinessSummaryManagement from "./Summary";
import { Button, Modal } from "react-bootstrap";
import DealProgressBar from "../components/dealProgress/DealBar";
import { countryOptions } from "../../utils/countryOptions";
import medical_clinic from "../../images/business_domain_logo/medical_clinic.jpg";
import vision_care from "../../images/business_domain_logo/vision.jpg";
import podiatry from "../../images/business_domain_logo/podiatre.jpg";
import medical_equipment from "../../images/business_domain_logo/medical_material.jpg";
import psychology from "../../images/business_domain_logo/psychologie.jpg";
import PremiumUpgradeReminder from "../components/PremiumUpgradeReminder";
import config from "../../config";

const libraries = ["places"];

const domainLogo = {
  medical_clinic: medical_clinic,
  vision_care: vision_care,
  podiatry: podiatry,
  medical_equipment: medical_equipment,
  psychology: psychology,
};

export const getStatusBadge = (status) => {
  switch (status) {
    case "Active":
    case "active":
    case "available":
    case "accepted":
      return "badge-success";
    case "pending":
      return "badge-warning";
    case "Unpublished":
    case "rejected":
      return "badge-danger";
  }
};

const validateBusiness = (data) => {
  if (
    data?.name !== "" &&
    data?.contactName !== "" &&
    data?.contactEmail !== "" &&
    data?.phone !== "" &&
    data?.askingPrice !== "" &&
    data?.assetsValue !== "" &&
    data?.ams !== "" &&
    data?.ebitda !== "" &&
    data?.employeesNo !== "" &&
    data?.equityOffered !== "" &&
    data?.yearlySales !== "" &&
    data?.country !== "" &&
    data?.region !== "" &&
    data?.currency !== "" &&
    data?.domain !== "" &&
    data?.type !== "" &&
    data?.establishedAt !== "" &&
    data?.sellingDeadline !== ""
  ) {
    return false;
  } else {
    return true;
  }
};

export const modifyDate = (date) => {
  const newDate = new Date(date);

  const year = newDate.getFullYear();
  const month = String(newDate.getMonth() + 1).padStart(2, "0");
  const day = String(newDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
const components = {
  DropdownIndicator: null,
};
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    borderColor: state.isFocused ? "#f5c0a9 !important" : "#EEEEEE",
    minHeight: "50px",
    height: "50px",
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: "50px",
    padding: "0 6px",
    "overflow-y": "auto",
  }),
  input: (provided, state) => ({
    ...provided,
    padding: "2px 0px",
    margin: "0px",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "50px",
  }),
};
function Business() {
  const { t } = useTranslation();
  const role = JSON.parse(sessionStorage.getItem("userDetails"))?.result;

  const [planOpen, setPlanOpen] = useState(false);
  // Permissions
  const canSeeBusinesssDetails =
    role?.role?.id === 1 ||
    role?.role?.id === 2 ||
    (role?.role?.id === 3 && role?.loggedinprofiletype === "sellerprofile");

  const state = useSelector((state) => state.auth.auth.result);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [business, setBusiness] = useState({
    original: [],
    filtered: [],
  });
  const [domainFilter, setDomainFilter] = useState("");

  const domainOptions = [
    { value: "", label: t("filter_by_domain") },
    { value: "medical_clinic", label: t("hmedical_clinic") },
    { value: "dental", label: t("hdental") },
    { value: "physiotherapy", label: t("hphysiotherapy") },
    { value: "chiropractic", label: t("hchiropractic") },
    { value: "massage_therapy", label: t("hmassage_therapy") },
    { value: "podiatry", label: t("hpodiatry") },
    { value: "psychology", label: t("hpsychology") },
    { value: "veterinary", label: t("hveterinary") },
    { value: "aesthetic_care", label: t("haesthetic_care") },
    { value: "vision_care", label: t("hvision_care") },
    { value: "medical_equipment", label: t("hmedical_equipment") },
    { value: "other", label: t("hother") },
  ];
  const [gridFilter, updateGridFilter] = useState("");

  const KNOWN_DOMAINS = new Set([
    "medical_clinic",
    "dental",
    "physiotherapy",
    "chiropractic",
    "massage_therapy",
    "podiatry",
    "psychology",
    "veterinary",
    "aesthetic_care",
    "vision_care",
    "medical_equipment",
  ]);

  const normalizeDomain = (d) => (d ?? "").toString().trim().toLowerCase();

  useEffect(() => {
    const original = business.original;
    if (!domainFilter) {
      setBusiness((prev) => ({ ...prev, filtered: original }));
      return;
    }

    const filterVal = normalizeDomain(domainFilter);

    if (filterVal === "other") {
      const next = original.filter((item) => {
        const d = normalizeDomain(item?.domain);
        return d && !KNOWN_DOMAINS.has(d);
      });
      setBusiness((prev) => ({ ...prev, filtered: next }));
      return;
    }

    const next = original.filter((item) => {
      return normalizeDomain(item?.domain) === filterVal;
    });
    setBusiness((prev) => ({ ...prev, filtered: next }));
  }, [business.original, domainFilter]);

  const [addBusiness, setAddBusiness] = useState(false);

  const [triggered, setTriggered] = useState(false);
  const [isAdvisorisOpen, setIsAdvisorisOpen] = useState("");
  const [professions, setProfessions] = useState([]);

  console.log("professions", professions);

  const [businessDetails, setBusinessDetails] = useState({
    name: "",
    contactName: "",
    contactEmail: "",
    email: "",
    phone: "",
    phone2: "",
    fax: "",
    askingPrice: "",
    assetsValue: "",
    ams: "",
    ebitda: "",
    employeesNo: "",
    equityOffered: "",
    yearlySales: "",
    address: "",
    city: "",
    postalCode: "",
    country: "",
    region: "",
    currency: "",
    domain: "",
    type: "",
    establishedAt: "",
    sellingDeadline: "",
    website: "",
    description: "",
    owners: [],
  });

  const [currencyOpt, setCurrencyOpt] = useState([]);

  const [businessStatus, setBusinessStatus] = useState("all");
  const [loading, setLoading] = useState(true);
  const [orderFilterValue, setOrderFilterValue] = useState("asc");
  const [statusFilterValue, setStatusFilterValue] = useState(
    "averagemonthlysales"
  );

  const [updateBusiness, setUpdateBusiness] = useState({
    cond: false,
    id: null,
  });

  const [offer, setOffer] = useState({
    cond: false,
    view: false,
    offerId: null,
    id: null,
  });

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [businessOwnerInputList, setBusinessOwnerInputList] = useState(1);
  const [businessOwners, setBusinessOwners] = useState([{}]);
  const [businessLogo, setBusinessLogo] = useState(null);
  // src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB3n919-1MbNDn_jkTYcM0v4wVCoAWxRA0&libraries=places"></script>

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyB3n919-1MbNDn_jkTYcM0v4wVCoAWxRA0",
    libraries,
  });

  const searchBoxRef = useRef(null);

  const [addressInput, setAddressInput] = useState(
    businessDetails?.address || ""
  );

  const handlePlacesChanged = () => {
    console.log(searchBoxRef.current, "adresse");
    if (!searchBoxRef.current) return; //

    updateBusinessDetails("address", "");
    updateBusinessDetails("city", "");
    updateBusinessDetails("region", "");
    updateBusinessDetails("postalCode", "");
    updateBusinessDetails("country", "");
    setAddressInput("");
    const places = searchBoxRef.current.getPlaces();
    if (places.length > 0) {
      const place = places[0];
      const addressComponents = place.address_components;

      let address = "";
      let streetNumber = "";
      let route = "";
      let city = "";
      let region = "";
      let postalCode = "";
      let country = "";

      addressComponents.forEach((component) => {
        const types = component.types;

        if (types.includes("street_number")) {
          address = component.long_name;
        }
        if (types.includes("route")) {
          address = component.long_name;
        }
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          region = component.long_name;
        }
        if (types.includes("postal_code")) {
          postalCode = component.long_name;
        }
        if (types.includes("country")) {
          country = component.long_name;
        }
      });
      console.log(address, "adresse");

      setAddressInput(address); // met à jour l'input
      updateBusinessDetails("address", address); // met à jour le state global

      //  updateBusinessDetails("address", address);
      updateBusinessDetails("city", city);
      updateBusinessDetails("region", region);
      updateBusinessDetails("postalCode", postalCode);
      updateBusinessDetails("country", country);
    }
  };

  useEffect(() => {
    getCurrencies();
  }, []);

  useEffect(() => {
    fetchBusinessList();
  }, [state, tableParams.current, tableParams.pageSize]);

  useEffect(() => {
    if (role?.loggedinprofiletype === "buyerprofile") {
      if (businessStatus === "all") {
        fetchBusinessList();
      } else if (businessStatus === "bookmarked") {
        bookmarkBusinesses();
      } else {
        offerRaisedBusinesses();
      }
    }
  }, [businessStatus, tableParams.current, tableParams.pageSize]);
  const [summaryModal, setSummaryModal] = useState(false);
  const fetchBusinessList = () => {
    setLoading(true);
    if (role?.loggedinprofiletype === "sellerprofile") {
      fetchSellerBusinessDetails(role?.loggedinprofileid)
        .then((res) => {
          const response = res.data?.result?.data ?? [];

          setBusiness({
            original: response,
            filtered: response,
          });
          setLoading(false);
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
          setLoading(false);
        });
    } else if (
      role?.role?.id === 3 ||
      role?.loggedinprofiletype === "buyerprofile"
    ) {
      fetchBuyerBusinesses(
        tableParams.current,
        tableParams.pageSize,
        orderFilterValue,
        statusFilterValue
      )
        .then((res) => {
          const response = res.data?.result?.data ?? [];
          setBusiness({
            original: response,
            filtered: response,
          });
          setLoading(false);

          setTableParams((prevState) => ({
            ...prevState,
            total: res.data?.result?.count,
          }));
        })
        .catch((error) => {
          setLoading(false);
          formatError(error.response?.data?.error);
        });
    } else {
      fetchAllBusiness(
        tableParams.current,
        tableParams.pageSize,
        orderFilterValue,
        statusFilterValue
      )
        .then((res) => {
          const response = res.data?.result?.data ?? [];

          setBusiness({
            original: response,
            filtered: response,
          });
          setLoading(false);
          setTableParams((prevState) => ({
            ...prevState,
            total: res.data?.result?.count,
          }));
        })
        .catch((error) => {
          setLoading(false);
          formatError(error.response?.data?.error);
        });
    }
  };

  useEffect(() => {
    fetchBusinessList();
  }, [orderFilterValue, statusFilterValue]);
  const getCurrencies = () => {
    fetchActiveCurrencies()
      .then((res) => {
        const response = res?.data?.result;

        const responseData = response ? sortList(response) : [];

        setCurrencyOpt(responseData);
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const updateGridData = (value) => {
    updateGridFilter(value);

    if (value !== "") {
      const filteredData = business.original.filter((item) =>
        item?.domain.toLowerCase().includes(value.toLowerCase())
      );

      setBusiness((prevState) => ({
        ...prevState,
        filtered: filteredData,
      }));
    } else {
      setBusiness((prevState) => ({
        ...prevState,
        filtered: [...prevState.original],
      }));
    }
  };

  const onAddBusiness = () => {
    if (role?.user?.sellerprofile?.id === 0) {
      swal("Oops", t("hadvisetocreateseller"), "error");
    } else if (role?.loggedinprofiletype !== "sellerprofile") {
      swal("Oops", t("hpleaseloginseller"), "error");
    } else {
      setBusinessDetails((prevState) => ({
        ...prevState,
        contactName: role?.user?.sellerprofile?.contactname,
        contactEmail: role?.user?.sellerprofile?.contactemail,
        email: role?.user?.sellerprofile?.email ?? "",
        phone: role?.user?.sellerprofile?.phone,
        phone2: role?.user?.sellerprofile?.phone2 ?? "",
        fax: role?.user?.sellerprofile?.fax ?? "",
      }));

      setAddBusiness(true);
    }
  };

  const updateBusinessDetails = (key, value) => {
    setBusinessDetails((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const onInterestBusiness = (id) => {
    if (role?.loggedinprofiletype === "buyerprofile") {
      buyerInterestedinBusiness(id)
        .then((res) => {})
        .catch((error) => {
          formatError(error?.response?.data?.error);
        });
    }
  };
  // options
  const options = [
    { label: t("hbroker"), value: "Real Estate Broker" },
    { label: t("hbrokerFinance"), value: "Finance Broker" },
    { label: t("hlawyer"), value: "Lawyer" },
    { label: t("hfiscaliste"), value: "Fiscalist" },
  ];

  // onEdit
  const onEdit = async (id) => {
    try {
      const res = await fetchBusinessDetails(id);
      const data = res.data?.result;

      setUpdateBusiness({ cond: true, id: data?.id });
      setAddBusiness(true);

      setBusinessDetails({
        name: data?.name,
        contactName: data?.contact_name,
        contactEmail: data?.contact_email,
        email: data?.email,
        phone: data?.phone,
        phone2: data?.phone2,
        fax: data?.fax,
        askingPrice: data?.asking_price,
        assetsValue: data?.assets_value,
        ams: data?.average_monthly_sales,
        ebitda: data?.ebitda,
        employeesNo: data?.employees_number,
        equityOffered: data?.equity_offered,
        yearlySales: data?.yearly_sales,
        address: data?.address,
        city: data?.city,
        postalCode: data?.postal_code,
        country: data?.country,
        region: data?.region,
        currency: `${data?.currency?.id}`,
        domain: data?.domain,
        type: data?.type,
        establishedAt: modifyDate(data?.established_at),
        sellingDeadline: modifyDate(data?.selling_deadline),
        website: data?.website,
        description: data?.description,
        owners: data?.owners,
        need_professional_help:
          data?.need_professional_help === true ? "yes" : "no",
      });

      setIsAdvisorisOpen(data?.need_professional_help === true ? "yes" : "no");

      const raw = data?.professions_needed || [];

      const values = Array.from(
        new Set(
          raw
            .map(
              (item) =>
                item?.value ??
                item?.label ??
                item?.name ??
                (typeof item === "string" ? item : undefined)
            )
            .filter(Boolean)
        )
      );

      const selectedOptions = values
        .map((val) => options.find((o) => o.value === val))
        .filter(Boolean);

      setProfessions(selectedOptions);
    } catch (error) {
      formatError(error?.response?.data?.error);
    }
  };

  const onDelete = (id) => {
    swal({
      title: t("hdelete"),
      text: t("confirmationDelete"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willaccept) => {
      if (willaccept) {
        deleteBusinessDetails(id)
          .then((res) => {
            fetchBusinessList();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
      }
    });
  };

  const addBusinessHandler = async (id) => {
    businessDetails["need_professional_help"] =
      isAdvisorisOpen === "yes" ? true : false;
    businessDetails["professions_needed"] = professions?.map(
      (item) => item.value
    );
    businessDetails["owners"] = businessOwners;

    if (validateBusiness(businessDetails)) {
      setTriggered(true);
    } else {
      setTriggered(false);

      addBusinessData(businessDetails, id)
        .then(async (res) => {
          if (!id) {
            await globalFileUploader(
              businessLogo,
              "BUSINESS_ICON",
              res?.data?.result?.id
            );
          }

          setBusinessDetails({
            name: "",
            contactName: "",
            contactEmail: "",
            email: "",
            phone: "",
            phone2: "",
            fax: "",
            askingPrice: "",
            assetsValue: "",
            ams: "",
            ebitda: "",
            employeesNo: "",
            equityOffered: "",
            yearlySales: "",
            address: "",
            city: "",
            postalCode: "",
            country: "",
            region: "",
            currency: "",
            domain: "",
            type: "",
            establishedAt: "",
            sellingDeadline: "",
            website: "",
            description: "",
            owners: [],
          });

          if (updateBusiness.cond) {
            setUpdateBusiness({
              cond: false,
              id: null,
            });
          }

          setAddBusiness(false);

          fetchBusinessList();
        })
        .catch((error) => {
          console.log(error);
          formatError(error.response?.data?.error);
        });
    }
  };

  const onBackCreate = () => {
    setBusinessDetails({
      name: "",
      contactName: "",
      contactEmail: "",
      email: "",
      phone: "",
      phone2: "",
      fax: "",
      askingPrice: "",
      assetsValue: "",
      ams: "",
      ebitda: "",
      employeesNo: "",
      equityOffered: "",
      yearlySales: "",
      address: "",
      city: "",
      postalCode: "",
      country: "",
      region: "",
      currency: "",
      domain: "",
      type: "",
      establishedAt: "",
      sellingDeadline: "",
      website: "",
      description: "",
    });

    setTriggered(false);

    if (updateBusiness.cond) {
      setUpdateBusiness({
        cond: false,
        id: null,
      });
    }

    setAddBusiness(false);

    fetchBusinessList();
  };

  useEffect(() => {
    if (role?.loggedinprofiletype === "buyerprofile") {
      setAddBusiness(false);
    }
  }, [role?.loggedinprofiletype]);

  const onAddOffer = (id) => {
    setOffer({
      cond: true,
      view: false,
      offerId: null,
      id: id,
    });
  };

  const onViewOffer = (id, offerId) => {
    setOffer({
      cond: true,
      view: true,
      offerId: offerId,
      id: id,
    });
  };

  const onBookmark = (isSaved, id) => {
    bookmarkBusiness(isSaved, id)
      .then((res) => {
        fetchBusinessList();
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const onComment = (id) => {};

  const onAllBusinesses = () => {
    setBusinessStatus("all");

    setTableParams({
      current: 1,
      pageSize: 10,
      total: 0,
    });
  };

  const onBookmarkBusinesses = () => {
    setBusinessStatus("bookmarked");

    setTableParams({
      current: 1,
      pageSize: 10,
      total: 0,
    });
  };

  const bookmarkBusinesses = () => {
    getAllbookmarkBusinesses()
      .then((res) => {
        let response = res.data?.result?.data ?? [];

        response = response.map((item) => item.business);

        response = sortList(response);

        setBusiness({
          original: response,
          filtered: response,
        });

        setTableParams((prevState) => ({
          ...prevState,
          total: res.data?.result?.count,
        }));
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const onOfferRaisedBusiness = () => {
    setBusinessStatus("offerraised");

    setTableParams({
      current: 1,
      pageSize: 10,
      total: 0,
    });
  };

  const offerRaisedBusinesses = () => {
    getOffersRaisedBusinesses(tableParams.current, tableParams.pageSize)
      .then((res) => {
        let response = res.data?.result?.data ?? [];

        response = sortList(response);

        setBusiness({
          original: response,
          filtered: response,
        });

        setTableParams((prevState) => ({
          ...prevState,
          total: res.data?.result?.count,
        }));
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const onChangePagination = (page, pageSize) => {
    setTableParams((prevState) => ({
      ...prevState,
      current: page,
      pageSize: pageSize,
    }));
  };

  const createRoomHandler = (bid) => {
    setLoading(true);
    try {
      createChatRoom(bid)
        .then((res) => {
          setLoading(false);
          dispatch(roomAction(res.data?.result?.id));
          dispatch(chatAction(true));
          setTimeout(() => {
            dispatch(msgAction(true));
          }, 600);
        })
        .catch((err) => {
          formatError(err.response.data?.error);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      swal("Oops", t("herror"), "error");
    }
  };

  const onChangePhoto = async (e) => {
    const file = e.target.files[0];

    const sizeLimit = 50 * 1024 * 1024; // 50MB

    if (file) {
      const fileType = file.type;

      if (file.size > sizeLimit) {
        swal("Oops", t("hmaxFile"), "error", {
          button: t("htry"),
        });
        return;
      }

      // Check if the selected file is of type jpg or png
      if (
        fileType === "image/jpeg" ||
        fileType === "image/jpg" ||
        fileType === "image/png"
      ) {
        setBusinessLogo(e.target.files);
      } else {
        swal("Oops", t("hselectJpg"), "error", {
          button: t("htry"),
        });
      }
    }
  };

  const businessOwnerOnChange = (e, index, key) => {
    const updatedBusinessOwners = [...businessOwners];

    if (!updatedBusinessOwners[index]) {
      updatedBusinessOwners[index] = {};
    }

    if (key === "equity") {
      let equityFromOthers = 0;
      businessDetails?.owners?.forEach((item, i) => {
        if (i !== index) {
          equityFromOthers += Number(item?.equity || 0);
        }
      });

      const newEquityValue = Number(e.target.value);
      const totalEquityAfterChange = equityFromOthers + newEquityValue;

      if (totalEquityAfterChange > 100) {
        swal("Error", `Total equity cannot exceed 100%`, "error");
      } else {
        updatedBusinessOwners[index][`${key}`] = newEquityValue;
      }
    } else {
      updatedBusinessOwners[index][`${key}`] = e.target.value;
    }
  };
  if (!isLoaded) return <div>Loading...</div>;
  return (
    <>
      {loading && <Loader forProcess={true} />}

      {addBusiness ? (
        <div className="row">
          <div style={{ marginBottom: "1rem" }} className="card col-lg-12">
            <div class="card-header d-sm-flex d-block">
              <div class="d-flex me-auto mb-sm-0">
                <span
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  className="d-flex justify-content-start align-items-center me-3"
                  onClick={onBackCreate}
                >
                  <i className="fa fa-arrow-left"></i>
                </span>
                <h4 class="card-title">{t("businessCreateButton")}</h4>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="row">
          <div style={{ marginBottom: "1rem" }} className="card col-lg-12">
            <div class="card-header d-sm-flex d-block row">
              <div className="col-sm-12 d-flex justify-content-between">
                <h4
                  className="font-weight-bold"
                  style={{ fontSize: "26px", fontWeight: "500" }}
                >
                  {" "}
                  {t("hopportunities")}
                </h4>
                {role?.loggedinprofiletype === "sellerprofile" && (
                  <div style={{ paddingLeft: "12px" }}>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-info me-2"
                      onClick={onAddBusiness}
                    >
                      + {t("businessAddButton")}
                    </a>
                  </div>
                )}
                {role?.role?.id !== 3 &&
                  role?.role?.id !== 4 &&
                  role?.role?.id !== 5 && (
                    <div style={{ paddingLeft: "12px" }}>
                      <button
                        className="btn btn-info"
                        onClick={() => setSummaryModal(true)}
                      >
                        {t("businessEvaluator")}
                      </button>
                    </div>
                  )}

                {role?.role?.id === 3 &&
                  role?.loggedinprofiletype === "buyerprofile" && (
                    <div style={{ paddingLeft: "12px" }}>
                      <button
                        className="btn btn-primary"
                        onClick={() => setPlanOpen(true)}
                      >
                        {t("servicePlan")}: {t("interacOnlyPlan")}
                      </button>
                    </div>
                  )}
              </div>
              <div className="d-flex justify-content-end mt-2">
                <GlobalFilter filter={gridFilter} setFilter={updateGridData} />
              </div>
              {/* <div className="d-flex justify-content-end mt-2">
                <GlobalFilter filter={gridFilter} setFilter={updateGridData} />

               
               
              </div> */}
              <div class="d-flex me-auto mb-sm-0">
                {role?.loggedinprofiletype === "buyerprofile" ? (
                  <ul style={{ borderBottom: "none" }} class="nav nav-tabs">
                    <li class="nav-item">
                      <a
                        style={{
                          color: "#eb8153",
                          padding: "18px 36px",
                          fontSize: "18px",
                          fontWeight: "500",
                        }}
                        class={`nav-link ${
                          businessStatus === "all" ? "active" : ""
                        }`}
                        href="javascript:void(0)"
                        onClick={onAllBusinesses}
                      >
                        {t("hdeals")}
                      </a>
                    </li>

                    <li class="nav-item">
                      <a
                        style={{
                          color: "#eb8153",
                          padding: "18px 36px",
                          fontSize: "18px",
                          fontWeight: "500",
                        }}
                        class={`nav-link ${
                          businessStatus === "bookmarked" ? "active" : ""
                        }`}
                        href="javascript:void(0)"
                        onClick={onBookmarkBusinesses}
                      >
                        {t("businessTitle2")}
                      </a>
                    </li>

                    <li class="nav-item">
                      <a
                        style={{
                          color: "#eb8153",
                          padding: "18px 36px",
                          fontSize: "18px",
                          fontWeight: "500",
                        }}
                        class={`nav-link ${
                          businessStatus === "offerraised" ? "active" : ""
                        }`}
                        href="javascript:void(0)"
                        onClick={onOfferRaisedBusiness}
                      >
                        {t("businessTitle3")}
                      </a>
                    </li>
                  </ul>
                ) : (
                  <h4 class="card-title">{""}</h4>
                )}
              </div>
            </div>

            <div className="mt-3 mb-3 ml-3 me-3">
              <div className="d-flex justify-content-between align-items-center">
                <div className="me-4 d-flex">
                  <select
                    style={{ width: "150px" }}
                    className="me-4 input-search form-control"
                    onChange={(e) => setOrderFilterValue(e.target.value)}
                  >
                    <option value="" disabled selected>
                      {t("businessOrderFilter")}
                    </option>
                    <option value="asc">{t("hasc")}</option>
                    <option value="desc">{t("hdesc")}</option>
                  </select>

                  <select
                    style={{ width: "150px" }}
                    className="ms-2 input-search form-control px-2"
                    onChange={(e) => setStatusFilterValue(e.target.value)}
                  >
                    <option value="" disabled selected>
                      {t("businessStatusFilter")}
                    </option>
                    <option value="ebitda">{t("ebitda")}</option>
                    <option value="yearlysales">{t("yearlySales")}</option>
                    <option value="averagemonthlysales">
                      {t("monthlySales")}
                    </option>
                    <option value="assetsvalue">{t("assetsValue")}</option>
                  </select>
                  <select
                    style={{ width: "150px" }}
                    className="ms-2 input-search form-control px-2"
                    onChange={(e) => setDomainFilter(e.target.value)}
                  >
                    {domainOptions.map((domain) => (
                      <option key={domain.value} value={domain.value}>
                        {t(domain.label)}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <Pagination
                    current={tableParams.current}
                    pageSize={tableParams.pageSize}
                    total={tableParams.total}
                    onChange={onChangePagination}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 40, 50]}
                    simple={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {addBusiness ? (
        <div className="row">
          {/* <div style={{ marginBottom: "1rem" }} className="card col-lg-12">
            <div class="card-header d-sm-flex d-block">
               <div class="d-flex me-auto mb-sm-0">
                <span
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  className="d-flex justify-content-start align-items-center me-3"
                  onClick={onBackCreate}
                >
                  <i className="fa fa-arrow-left"></i>
                </span>
                <h4 class="card-title">{t("businessCreateButton")}</h4>
              </div> 
            </div>
          </div> */}
          {/* General Information Section */}
          <div className="col-12">
            <div className="input-group-header">
              <h4 className="input-group-title">{t("generalInformation")}</h4>
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.name === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("nameInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("nameInput")}
                className="form-control"
                value={businessDetails?.name}
                onChange={(e) => updateBusinessDetails("name", e.target.value)}
              />
            </div>
            {triggered && businessDetails?.name === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("nameInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.domain === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("domainInput")}</strong>
              </label>
              <select
                className="form-control"
                style={{ border: "1px solid #EEEEEE" }}
                value={businessDetails?.domain}
                onChange={(e) =>
                  updateBusinessDetails("domain", e.target.value)
                }
              >
                <option value="">{t("globalSelect")}</option>
                <option value="medical_clinic">{t("hmedical_clinic")}</option>
                <option value="dental">{t("hdental")}</option>
                <option value="physiotherapy">{t("hphysiotherapy")}</option>
                <option value="chiropractic">{t("hchiropractic")}</option>
                <option value="massage_therapy">{t("hmassage_therapy")}</option>
                <option value="podiatry">{t("hpodiatry")}</option>
                <option value="psychology">{t("hpsychology")}</option>
                <option value="veterinary">{t("hveterinary")}</option>
                <option value="aesthetic_care">{t("haesthetic_care")}</option>
                <option value="vision_care">{t("hvision_care")}</option>
                <option value="medical_equipment">
                  {t("hmedical_equipment")}
                </option>
                <option value="other">{t("hother")}</option>
              </select>
            </div>
            {triggered && businessDetails?.domain === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("domainInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.type === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("typeInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("typeInput")}
                className="form-control"
                value={businessDetails?.type}
                onChange={(e) => updateBusinessDetails("type", e.target.value)}
              />
            </div>
            {triggered && businessDetails?.type === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("typeInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("websiteInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("websiteInput")}
                className="form-control"
                value={businessDetails?.website}
                onChange={(e) =>
                  updateBusinessDetails("website", e.target.value)
                }
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("descriptionInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("descriptionInput")}
                className="form-control"
                value={businessDetails?.description}
                onChange={(e) =>
                  updateBusinessDetails("description", e.target.value)
                }
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("hlogo")}</strong>
              </label>
              <input
                type="file"
                accept=".jpg, .jpeg, .png"
                className="form-control"
                onChange={onChangePhoto}
              />
            </div>
          </div>
          {/* Contact Information Section */}
          <div className="col-12">
            <div className="input-group-header">
              <h4 className="input-group-title">{t("contactInformation")}</h4>
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.contactName === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("contactNameInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("contactNameInput")}
                className="form-control"
                value={businessDetails?.contactName}
                onChange={(e) =>
                  updateBusinessDetails("contactName", e.target.value)
                }
              />
            </div>
            {triggered && businessDetails?.contactName === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("contactNameInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.contactEmail === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("contactEmailInput")}</strong>
              </label>
              <input
                type="email"
                placeholder={t("contactEmailInput")}
                className="form-control"
                value={businessDetails?.contactEmail}
                onChange={(e) =>
                  updateBusinessDetails("contactEmail", e.target.value)
                }
              />
            </div>
            {triggered && businessDetails?.contactEmail === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("contactEmailInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("emailInput")}</strong>
              </label>
              <input
                type="email"
                placeholder={t("emailInput")}
                className="form-control"
                value={businessDetails?.email}
                onChange={(e) => updateBusinessDetails("email", e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.phone === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("phoneInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("phoneInput")}
                className="form-control"
                value={businessDetails?.phone}
                onChange={(e) => updateBusinessDetails("phone", e.target.value)}
              />
            </div>
            {triggered && businessDetails?.phone === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("phoneInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("secondaryPhoneInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("secondaryPhoneInput")}
                className="form-control"
                value={businessDetails?.phone2}
                onChange={(e) =>
                  updateBusinessDetails("phone2", e.target.value)
                }
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("faxInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("faxInput")}
                className="form-control"
                value={businessDetails?.fax}
                onChange={(e) => updateBusinessDetails("fax", e.target.value)}
              />
            </div>
          </div>
          {/* Location Information Section */}
          <div className="col-12">
            {" "}
            <div className="input-group-header">
              <h4 className="input-group-title">{t("locationInformation")}</h4>
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("addressInput")}</strong>
              </label>
              <StandaloneSearchBox
                onLoad={(ref) => (searchBoxRef.current = ref)}
                onPlacesChanged={handlePlacesChanged}
              >
                <input
                  type="text"
                  placeholder={t("addressInput")}
                  className="form-control"
                  value={addressInput} // controlled
                  onChange={(e) => {
                    const newAddress = e.target.value;
                    setAddressInput(newAddress); // met à jour l'input
                    updateBusinessDetails("address", newAddress); // met à jour le state global

                    // Réinitialiser les autres champs si l'utilisateur modifie l'adresse
                    updateBusinessDetails("city", "");
                    updateBusinessDetails("region", "");
                    updateBusinessDetails("postalCode", "");
                    updateBusinessDetails("country", "");
                  }}
                />
              </StandaloneSearchBox>
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("cityInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("cityInput")}
                className="form-control"
                value={businessDetails?.city}
                onChange={(e) => updateBusinessDetails("city", e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.region === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("regionInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("regionInput")}
                className="form-control"
                value={businessDetails?.region}
                onChange={(e) =>
                  updateBusinessDetails("region", e.target.value)
                }
              />
              {/* <select
                className="form-control"
                style={{ border: "1px solid #EEEEEE" }}
                value={businessDetails?.region}
                onChange={(e) =>
              updateBusinessDetails("region", e.target.value)    
                }
              >
                <option value="">{t("globalSelect")}</option>
                <option value="Alberta">{t("halberta")}</option>
                <option value="British Columbia">
                  {t("hbritishcolumbia")}
                </option>
                <option value="Manitoba">{t("hmanitoba")}</option>
                <option value="New Brunswick">{t("hnewbrunswick")}</option>
                <option value="Newfoundland and Labrador">
                  {t("hnewfoundland")}
                </option>
                <option value="Northwest Territories">
                  {t("hnorthwestterritories")}
                </option>
                <option value="Nova Scotia">{t("hnovascotia")}</option>
                <option value="Nunavut">{t("hnunavut")}</option>
                <option value="Ontario">{t("hontario")}</option>
                <option value="Prince Edward Island">{t("hpei")}</option>
                <option value="Quebec">{t("hquebec")}</option>
                <option value="Saskatchewan">{t("hsaskatchewan")}</option>
                <option value="Yukon">{t("hyukon")}</option>
              </select> */}
            </div>
            {triggered && businessDetails?.region === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("regionInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("postalCodeInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("postalCodeInput")}
                className="form-control"
                value={businessDetails?.postalCode}
                onChange={(e) =>
                  updateBusinessDetails("postalCode", e.target.value)
                }
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.country === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("countryInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("countryInput")}
                className="form-control"
                value={businessDetails?.country}
                onChange={(e) =>
                  updateBusinessDetails("country", e.target.value)
                }
              />
              {/* <CreatableSelect
                isClearable
                options={countryOptions}
                placeholder={t("countryInput")}
                styles={customStyles}
                components={components}
                value={businessDetails?.country}
                onChange={(value) => updateBusinessDetails("country", value)}
              /> */}
            </div>
            {triggered && businessDetails?.country === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("countryInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          {/* Financial Information Section */}{" "}
          <div className="col-12">
            <div className="input-group-header">
              <h4 className="input-group-title">{t("financialInformation")}</h4>
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.currency === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("currencyInput")}</strong>
              </label>
              <select
                className="form-control"
                style={{ border: "1px solid #EEEEEE" }}
                value={businessDetails?.currency}
                onChange={(e) =>
                  updateBusinessDetails("currency", e.target.value)
                }
              >
                <option value="">{t("globalSelect")}</option>
                {currencyOpt?.length > 0 &&
                  currencyOpt.map((item) => (
                    <option key={`OfferCurrency${item?.code}`} value={item?.id}>
                      {item?.code}
                    </option>
                  ))}
              </select>
            </div>
            {triggered && businessDetails?.currency === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("currencyInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.askingPrice === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("askingPriceInput")}</strong>
              </label>
              <input
                type="number"
                placeholder={t("askingPriceInput")}
                className="form-control"
                value={businessDetails?.askingPrice}
                onChange={(e) =>
                  updateBusinessDetails("askingPrice", e.target.value)
                }
              />
            </div>
            {triggered && businessDetails?.askingPrice === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("askingPriceInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.assetsValue === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("assetsValueInput")}</strong>
              </label>
              <input
                type="number"
                placeholder={t("assetsValueInput")}
                className="form-control"
                value={businessDetails?.assetsValue}
                onChange={(e) =>
                  updateBusinessDetails("assetsValue", e.target.value)
                }
              />
            </div>
            {triggered && businessDetails?.assetsValue === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("assetsValueInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.equityOffered === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("equityOfferedInput")}</strong>
              </label>
              <div className="d-flex">
                <input
                  type="number"
                  placeholder={t("equityOfferedInput")}
                  className="form-control"
                  value={businessDetails?.equityOffered}
                  style={{ borderRadius: "5px 0px 0px 5px" }}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= 0 && value <= 100) {
                      updateBusinessDetails("equityOffered", value);
                    }
                  }}
                />

                <div
                  class="input-group-text"
                  style={{ borderRadius: "0px 5px 5px 0px" }}
                >
                  %
                </div>
              </div>
            </div>
            {triggered && businessDetails?.equityOffered === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("equityOfferedInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.ams === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("avarageMonthlySale")}</strong>
              </label>
              <input
                type="number"
                placeholder={t("avarageMonthlySale")}
                className="form-control"
                value={businessDetails?.ams}
                onChange={(e) => updateBusinessDetails("ams", e.target.value)}
              />
            </div>
            {triggered && businessDetails?.ams === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("avarageMonthlySale")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.yearlySales === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("yearlySalesInput")}</strong>
              </label>
              <input
                type="number"
                placeholder={t("yearlySalesInput")}
                className="form-control"
                value={businessDetails?.yearlySales}
                onChange={(e) =>
                  updateBusinessDetails("yearlySales", e.target.value)
                }
              />
            </div>
            {triggered && businessDetails?.yearlySales === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("yearlySalesInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.ebitda === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("ebitdaInput")}</strong>
              </label>
              <div className="d-flex">
                <input
                  type="number"
                  placeholder={t("ebitdaInput")}
                  className="form-control"
                  value={businessDetails?.ebitda}
                  onChange={(e) => {
                    updateBusinessDetails("ebitda", e.target.value);
                  }}
                />
              </div>
            </div>
            {triggered && businessDetails?.ebitda === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("ebitdaInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          {/* Business Details Section */}{" "}
          <div className="col-12">
            <div className="input-group-header">
              <h4 className="input-group-title">{t("businessDetails")}</h4>
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.employeesNo === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("employeesNumberInput")}</strong>
              </label>
              <input
                type="number"
                placeholder={t("employeesNumberInput")}
                className="form-control"
                value={businessDetails?.employeesNo}
                onChange={(e) =>
                  updateBusinessDetails("employeesNo", e.target.value)
                }
              />
            </div>
            {triggered && businessDetails?.employeesNo === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("employeesNumberInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.establishedAt === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("establishedDateInput")}</strong>
              </label>
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                placeholderText="YYYY-MM-DD"
                showYearDropdown={true}
                value={businessDetails?.establishedAt}
                onChange={(e) =>
                  updateBusinessDetails("establishedAt", modifyDate(e))
                }
              />
            </div>
            {triggered && businessDetails?.establishedAt === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("establishedDateInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && businessDetails?.sellingDeadline === ""
                  ? "mb-1"
                  : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("deadlineDateInput")}</strong>
              </label>
              <br />
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                placeholderText="YYYY-MM-DD"
                showYearDropdown={true}
                value={businessDetails?.sellingDeadline}
                onChange={(e) =>
                  updateBusinessDetails("sellingDeadline", modifyDate(e))
                }
              />
            </div>
            {triggered && businessDetails?.sellingDeadline === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("deadlineDateInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          {/* Professional Help Section */}{" "}
          <div className="col-12">
            <div className="input-group-header">
              <h4 className="input-group-title">{t("professionalHelp")}</h4>
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <label className="mb-1 mb-3 mt-1">
              <strong>{t("hadviser")}</strong>
            </label>
            <div className="d-flex">
              <div class="form-check mb-3 me-3">
                <input
                  class="form-check-input"
                  type="radio"
                  name="yes"
                  value="yes"
                  id="flexRadioDefault1"
                  checked={isAdvisorisOpen === "yes"}
                  onChange={(e) => setIsAdvisorisOpen(e.target.name)}
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  {t("hyes")}
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="no"
                  value="no"
                  id="flexRadioDefault2"
                  checked={isAdvisorisOpen === "no"}
                  onChange={(e) => {
                    setProfessions([]);
                    setIsAdvisorisOpen(e.target.name);
                  }}
                />
                <label class="form-check-label" for="flexRadioDefault2">
                  {t("hno")}
                </label>
              </div>
            </div>
          </div>
          {isAdvisorisOpen !== "" && isAdvisorisOpen !== "no" && (
            <div className="col-md-12 col-lg-6 col-xl-4 ">
              <div
                className={`form-group ${
                  triggered && businessDetails?.region === "" ? "mb-1" : "mb-3"
                }`}
              >
                <label className="mb-1">
                  <strong>{t("hadvisorDomains")}</strong>
                </label>

                <MultiSelect
                  options={[
                    {
                      label: t("hbroker"),
                      value: "Real Estate Broker",
                    },
                    { label: t("hbrokerFinance"), value: "Finance Broker" },
                    { label: t("hlawyer"), value: "Lawyer" },
                    { label: t("hfiscaliste"), value: "Fiscalist" },
                  ]}
                  value={professions}
                  onChange={setProfessions}
                  labelledBy="Select"
                />
              </div>
            </div>
          )}
          {/* Business Owners Section */}{" "}
          <div className="col-12">
            <div className="input-group-header">
              <h4 className="input-group-title">{t("businessOwners")}</h4>
            </div>
          </div>
          {[...Array(businessOwnerInputList)].map((e, i) => (
            <div className="d-flex align-items-center" key={i}>
              {businessOwnerInputList === i + 1 && (
                <div className="" style={{ position: "absolute" }}>
                  <span
                    style={{
                      fontSize: "30px",
                      color: "green",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setBusinessOwners((prev) => [...prev, {}]);
                      setBusinessOwnerInputList((prev) => prev + 1);
                    }}
                  >
                    +
                  </span>
                </div>
              )}
              <div className="col-md-12 col-lg-6 col-xl-4 d-flex justify-content-center">
                <div
                  className="form-group mb-3"
                  style={{ width: "350px", alignSelf: "center" }}
                >
                  <label className="mb-1">
                    <strong>Type</strong>
                  </label>
                  <select
                    className="form-control"
                    style={{ border: "1px solid #EEEEEE" }}
                    onChange={(e) => businessOwnerOnChange(e, i, "type")}
                  >
                    <option value="">{t("globalSelect")}</option>
                    <option value="COMPANY">{t("hcompagny")}</option>
                    <option value="INDIVIDUAL">{t("hindividual")}</option>
                  </select>
                </div>
              </div>
              <div className="col-md-12 col-lg-6 col-xl-4">
                <div className="form-group mb-3 mx-2">
                  <label className="mb-1">
                    <strong>{t("nameInput")}</strong>
                  </label>
                  <input
                    required
                    type="text"
                    placeholder="name"
                    className="form-control"
                    onChange={(e) => businessOwnerOnChange(e, i, "name")}
                  />
                </div>
              </div>
              <div className="col-md-12 col-lg-6 col-xl-4 ">
                <div className="form-group mb-3 mx-2">
                  <label className="mb-1">
                    <span className="text-danger">*</span>
                    &ensp;
                    <strong>{t("hequity")}</strong>{" "}
                  </label>

                  {/* <input
                    type="number"
                    required
                    placeholder="equity"
                    className="form-control"
                    onChange={(e) => businessOwnerOnChange(e, i, "equity")}
                  /> */}

                  <div className="d-flex">
                    <input
                      type="number"
                      placeholder="equity"
                      className="form-control"
                      style={{ borderRadius: "5px 0px 0px 5px" }}
                      required
                      min={0}
                      max={100}
                      onChange={(e) => businessOwnerOnChange(e, i, "equity")}
                    />

                    <div
                      class="input-group-text"
                      style={{ borderRadius: "0px 5px 5px 0px" }}
                    >
                      %
                    </div>
                  </div>
                </div>
              </div>
              {i !== 0 && (
                <div className="" style={{ position: "absolute", right: 20 }}>
                  <span
                    style={{
                      fontSize: "30px",
                      color: "red",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setBusinessOwners(
                        businessOwners.filter((_, index) => index !== i)
                      );
                      setBusinessOwnerInputList((prev) => prev - 1);
                    }}
                  >
                    <Icon icon="material-symbols:delete" />
                  </span>
                </div>
              )}
            </div>
          ))}
          {/* Submit Section */}
          <div
            className="col-md-12 mb-5"
            style={{ paddingBottom: isAdvisorisOpen === "yes" ? "200px" : "0" }}
          >
            {updateBusiness.cond ? (
              <div className="d-flex justify-content-center align-items-center">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => addBusinessHandler(updateBusiness.id)}
                >
                  {t("saveButton")}
                </button>
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center mt-4">
                <button
                  type="button"
                  className="btn btn-primary px-5"
                  onClick={() => addBusinessHandler(null)}
                >
                  {t("saveButton")}
                </button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="row">
          {!loading &&
            business.filtered?.length > 0 &&
            business.filtered.map((item, index) => (
              <div
                key={`businessCard${index}`}
                className="col-xl-6 col-lg-12"
                onClick={() => onInterestBusiness(item?.id)}
              >
                <div className="card project-card">
                  <div className="card-body">
                    <div className="d-flex mb-4 align-items-start">
                      <div
                        className=" me-auto d-flex "
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(`/business/${item?.id}`)}
                      >
                        {canSeeBusinesssDetails && (
                          <div style={{ marginRight: "10px" }}>
                            {item?.icon ? (
                              <img
                                alt="logo"
                                src={`${config?.appUrl}file/view?key=${item?.icon}&type=IMAGE`}
                                style={{
                                  width: "50px",
                                  height: "40px",
                                  marginTop: "5px",
                                  borderRadius: "3px",
                                }}
                              />
                            ) : (
                              <div style={{ marginRight: "10px" }}>
                                {domainLogo[item?.domain] ? (
                                  <img
                                    alt="logo"
                                    src={`${domainLogo[item?.domain]}`}
                                    style={{
                                      width: "50px",
                                      height: "40px",
                                      marginTop: "5px",
                                      borderRadius: "3px",
                                    }}
                                  />
                                ) : (
                                  <div className="dt-icon bgl-info me-3">
                                    <i
                                      className="fa fa-briefcase text-secondary"
                                      style={{ fontSize: "20px" }}
                                    ></i>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {!canSeeBusinesssDetails && (
                          <div style={{ marginRight: "10px" }}>
                            {domainLogo[item?.domain] ? (
                              <img
                                alt="logo"
                                src={`${domainLogo[item?.domain]}`}
                                style={{
                                  width: "50px",
                                  height: "40px",
                                  marginTop: "5px",
                                  borderRadius: "3px",
                                }}
                              />
                            ) : (
                              <div className="dt-icon bgl-info me-3">
                                <i
                                  className="fa fa-briefcase text-secondary"
                                  style={{ fontSize: "20px" }}
                                ></i>
                              </div>
                            )}
                          </div>
                        )}
                        {canSeeBusinesssDetails && (
                          <div>
                            <h5 className="title font-w600 mb-2">
                              <span className="text-black m-0">
                                {item?.name}
                              </span>
                              {/* <Link to={`/business/${item?.id}`} className="text-black">
														{item?.name}
													</Link> */}{" "}
                              <small className="fst-italic">
                                ({`${item?.business_number}-${item?.id}`}){" "}
                              </small>
                            </h5>
                            <span>{t(item?.domain)}</span>
                            <Rating rating={item?.rating} />
                          </div>
                        )}
                        {!canSeeBusinesssDetails && (
                          <div>
                            <h5 className="title font-w600 mb-2">
                              <span className="text-black m-0">
                                {t("a")} {t(item?.domain)}
                              </span>
                              {/* <Link to={`/business/${item?.id}`} className="text-black">
														{item?.name}
													</Link> */}{" "}
                              <small className="fst-italic">
                                ({`${item?.business_number}-${item?.id}`}){" "}
                              </small>
                              <span className="text-black m-0">
                                {t("forsalein")} {item?.region}
                              </span>
                            </h5>
                            <span>{t(item?.domain)}</span>
                            <Rating rating={item?.rating} />
                          </div>
                        )}
                      </div>

                      {/* rating */}
                      {/* <div className="me-3 d-flex"> */}
                      {/* <p className="ms-1">(10)</p> */}
                      {/* </div> */}

                      <div className="d-flex flex-column ">
                        <span
                          className={`badge d-sm-inline-block d-none me-3 mb-2 ${getStatusBadge(
                            item?.status
                          )}`}
                        >
                          {t(item?.status)}
                        </span>

                        {role?.loggedinprofiletype === "buyerprofile" &&
                          item?.hasoffer === false && (
                            <span
                              style={{ cursor: "pointer" }}
                              class="badge d-sm-inline-block d-none badge-primary me-3"
                              onClick={() => onAddOffer(item?.id)}
                            >
                              <i class="fa fa-plus"></i> {t("hoffer")}
                            </span>
                          )}
                      </div>

                      {role?.loggedinprofiletype === "buyerprofile" &&
                        item?.hasoffer === true && (
                          <span
                            style={{ cursor: "pointer" }}
                            class="badge d-sm-inline-block d-none badge-primary me-3"
                            onClick={() => onViewOffer(item?.id, item?.offerid)}
                          >
                            {t("businessViewOfferButton")}
                          </span>
                        )}

                      {role?.loggedinprofiletype === "buyerprofile" && (
                        <span
                          style={{
                            cursor: "pointer",
                            color: "grey",
                            fontSize: "15px",
                          }}
                          class="badge d-sm-inline-block d-none me-2"
                          onClick={() => createRoomHandler(item.id)}
                        >
                          <Icon
                            icon="token:chat"
                            fontSize={20}
                            style={{ cursor: "pointer" }}
                          />
                        </span>
                      )}

                      {role?.loggedinprofiletype === "buyerprofile" && (
                        <span
                          style={{
                            cursor: "pointer",
                            color: item?.issaved ? "#A8C7FA" : "grey",
                            fontSize: "15px",
                          }}
                          class="badge d-sm-inline-block d-none me-2"
                          onClick={() => onBookmark(item?.issaved, item?.id)}
                        >
                          <i className="fa fa-bookmark"></i>
                        </span>
                      )}

                      {role?.loggedinprofiletype === "sellerprofile" &&
                        item?.status !== "pending" && (
                          <>
                            <span
                              style={{ cursor: "pointer" }}
                              class="badge d-sm-inline-block d-none badge-warning me-3"
                              onClick={() => onEdit(item?.id)}
                            >
                              <i className="fa fa-pencil"></i>
                            </span>
                            <span
                              style={{ cursor: "pointer" }}
                              class="badge d-sm-inline-block d-none badge-danger"
                              onClick={() => onDelete(item?.id)}
                            >
                              <i className="fa fa-trash"></i>
                            </span>
                          </>
                        )}
                    </div>

                    <p className="mb-4">{item?.description}</p>

                    <div className="row mb-4">
                      <div className="col-sm-6 mb-sm-0 mb-3 d-flex">
                        <div className="dt-icon bgl-info me-3">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19 5H18V3C18 2.73478 17.8946 2.48043 17.7071 2.29289C17.5196 2.10536 17.2652 2 17 2C16.7348 2 16.4804 2.10536 16.2929 2.29289C16.1054 2.48043 16 2.73478 16 3V5H8V3C8 2.73478 7.89464 2.48043 7.70711 2.29289C7.51957 2.10536 7.26522 2 7 2C6.73478 2 6.48043 2.10536 6.29289 2.29289C6.10536 2.48043 6 2.73478 6 3V5H5C4.20435 5 3.44129 5.31607 2.87868 5.87868C2.31607 6.44129 2 7.20435 2 8V9H22V8C22 7.20435 21.6839 6.44129 21.1213 5.87868C20.5587 5.31607 19.7957 5 19 5Z"
                              fill="#92caff"
                            />
                            <path
                              d="M2 19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7957 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V11H2V19Z"
                              fill="#51A6F5"
                            />
                          </svg>
                        </div>

                        <div>
                          <span>{t("businessStartDate")}</span>
                          <p className="mb-0 pt-1 font-w500 text-black">
                            {new Date(item?.established_at).toLocaleDateString(
                              "en-US",
                              {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                              }
                            )}
                          </p>
                        </div>
                      </div>

                      <div className="col-sm-6 d-flex">
                        <div className="dt-icon me-3 bgl-danger">
                          <svg
                            width="19"
                            height="24"
                            viewBox="0 0 19 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.6601 8.6858C18.5437 8.44064 18.2965 8.28427 18.025 8.28427H10.9728L15.2413 1.06083C15.3697 0.843469 15.3718 0.573844 15.2466 0.354609C15.1214 0.135375 14.8884 -9.37014e-05 14.6359 4.86277e-08L8.61084 0.000656299C8.3608 0.000750049 8.12957 0.1335 8.00362 0.349453L0.0958048 13.905C-0.0310859 14.1224 -0.0319764 14.3911 0.0934142 14.6094C0.218805 14.8277 0.451352 14.9624 0.703117 14.9624H7.71037L5.66943 23.1263C5.58955 23.4457 5.74213 23.7779 6.03651 23.9255C6.13691 23.9757 6.24459 24 6.35123 24C6.55729 24 6.75923 23.9094 6.89638 23.7413L18.5699 9.43186C18.7415 9.22148 18.7766 8.93105 18.6601 8.6858V8.6858Z"
                              fill="#FF4C41"
                            />
                          </svg>
                        </div>

                        <div>
                          <span>{t("businessDeadlineTransac")}</span>
                          <p className="mb-0 pt-1 font-w500 text-black">
                            {new Date(
                              item?.selling_deadline
                            ).toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                            })}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex flex-wrap align-items-center">
                      <div className="d-flex align-items-center flex-wrap mb-1">
                        <div className="text-center border-bx me-3 mb-3">
                          <span>{t("businessAskingPrice")}</span>
                          <p className="mb-0 pt-1 font-w500 text-black">
                            {item?.asking_price} {item?.currency?.symbol}
                          </p>
                        </div>

                        <div className="text-center border-bx me-3 mb-3">
                          <span>{t("businessAssetsValue")}</span>
                          <p className="mb-0 pt-1 font-w500 text-black">
                            {item?.assets_value} {item?.currency?.symbol}
                          </p>
                        </div>

                        <div className="text-center border-bx me-3 mb-3">
                          <span>{t("businessEquityOffered")}</span>
                          <p className="mb-0 pt-1 font-w500 text-black">
                            {item?.equity_offered} %
                          </p>
                        </div>

                        <div className="text-center border-bx me-3 mb-3">
                          <span>{t("businessAverageMonthlySales")}</span>
                          <p className="mb-0 pt-1 font-w500 text-black">
                            {item?.average_monthly_sales}{" "}
                            {item?.currency?.symbol}
                          </p>
                        </div>

                        <div className="text-center border-bx me-3 mb-3">
                          <span>{t("businessYearlySales")}</span>
                          <p className="mb-0 pt-1 font-w500 text-black">
                            {item?.yearly_sales} {item?.currency?.symbol}
                          </p>
                        </div>

                        <div className="text-center border-bx me-3 mb-3">
                          <span>{t("businessEbitda")}</span>
                          <p className="mb-0 pt-1 font-w500 text-black">
                            {item?.ebitda} %
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}

      {offer.cond && (
        <AddOfferPopup
          show={offer.cond}
          id={offer.id}
          view={offer.view}
          offerId={offer.offerId}
          onHideOfferModal={() =>
            setOffer({
              cond: false,
              view: false,
              offerId: null,
              id: null,
            })
          }
          fetchBusinessList={fetchBusinessList}
        />
      )}

      {summaryModal && (
        <BusinessSummaryManagement setShowModal={setSummaryModal} />
      )}
      <PremiumUpgradeReminder open={planOpen} setOpen={setPlanOpen} />
    </>
  );
}

export default Business;
